<template>
  <VDataTable
    id="vacancies-table"
    :headers="headers"
    :items="filteredVacancies"
    dense
    hide-default-header
    hide-default-footer
    class="transparent"
  >
    <template v-slot:item.title="{ item }">
      <CompanyVacanciesTableRowTitle :company-id="companyId" :vacancy="item" />
    </template>
    <template v-slot:item.salary="{ item }">
      <div class="body-2 grey--text text--darken-4">
        <VacancySalary :salary="item.salary" />
      </div>
    </template>
    <template v-slot:item.address="{ item: { address } }">
      <div class="body-2 text-no-wrap text-left grey--text text--darken-4">
        {{ address ? address.city : '' }}
      </div>
    </template>
  </VDataTable>
</template>

<script>
import { computed, toRefs } from '@vue/composition-api';
import { useI18n } from 'vue-i18n-composable';
import VacancySalary from '../Vacancy/VacancySalary.vue';
import CompanyVacanciesTableRowTitle from './CompanyVacanciesTableRowTitle.vue';

export default {
  name: 'CompanyVacanciesTable',
  components: { CompanyVacanciesTableRowTitle, VacancySalary },
  props: {
    vacancies: {
      type: Array,
      required: true,
    },
    companyId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { vacancies } = toRefs(props);
    const { t } = useI18n();

    const filteredVacancies = computed(() => vacancies.value.filter(vacancy => vacancy.visibility !== 'invitation'));

    const headers = [
      {
        text: t('vacancy'),
        value: 'title',
      },
      {
        text: t('salary'),
        value: 'salary',
        width: '100%',
        align: 'center',
      },
      {
        text: t('city'),
        value: 'address',
        align: 'end',
      },
    ];

    return {
      headers,
      filteredVacancies,
    };
  },
};
</script>
<style lang="scss" scoped>
#vacancies-table {
  &::v-deep {
    td {
      vertical-align: top !important;
      padding-top: 20px;
      padding-bottom: 20px;
    }
  }
}
</style>

<i18n locale="en" lang="yaml">
vacancy: Job
salary: Salary
city: City
</i18n>

<i18n locale="ru" lang="yaml">
vacancy: Вакансия
salary: Зарплата
city: Город
</i18n>
